const loading = () => (
  <div className={"vh-100 w-100 h-100 position-relative"}>
    <span className={"position-absolute top-50 start-50 translate-middle"}>
      <div className={"spinner-border"} style={{ width: "5rem", height: "5rem" }}></div>
    </span>
  </div>
);

export default loading;
